import cx from "classnames";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { TemplatesWindow } from "@/interface/SideBar/TemplatesWindow";
import { Tooltip } from "@/interface/ui/Tooltip";
import { VStack } from "@/shared/ui/Stack";
import {
    arrowToolMenuVisibility,
    currentToolAtom,
    emoteToolMenuAtomVisibility,
    mindMapToolMenuVisibilityAtom,
    moreToolVisibility,
    penToolMenuVisibilityAtom,
    stickerToolMenuVisibility,
    templateToolMenuVisibility,
    toolBoxVisibility,
} from "../AppStore";
import { ArrowMenu } from "./ArrowMenu";
import { EmoteMenu } from "./EmoteMenu";
import { MindMapMenu } from "./MindMapMenu";
import { MoreWindow } from "./MoreWindow";
import { PenMenu } from "./PenMenu";
import styles from "./SideBar.module.css";
import { StickerMenu } from "./StickerMenu";
import { getToolsNames } from "./utils";

export const SideBar = () => {
    const currentTool = useAtomValue(currentToolAtom);
    const isShowEmoteToolMenu = useAtomValue(emoteToolMenuAtomVisibility);
    const isShowArrowToolMenu = useAtomValue(arrowToolMenuVisibility);
    const isShowStickerToolMenu = useAtomValue(stickerToolMenuVisibility);
    const isShowMoreTool = useAtomValue(moreToolVisibility);
    const isShowToolBox = useAtomValue(toolBoxVisibility);
    const isShowPenToolMenu = useAtomValue(penToolMenuVisibilityAtom);
    const toolNames = getToolsNames();
    const isShowMindMapToolMenu = useAtomValue(mindMapToolMenuVisibilityAtom);
    const isShowTemplateTool = useAtomValue(templateToolMenuVisibility);

    return (
        <div className={cx(styles.toolBox, { [styles.toolBoxHidden]: !isShowToolBox })}>
            {isShowEmoteToolMenu && <EmoteMenu />}
            {isShowMindMapToolMenu && <MindMapMenu />}
            <div className={styles.toolBoxWrapper}>
                <VStack gap={2} className={styles.toolBoxWrapperContent}>
                    {toolNames.map((toolName) => {
                        const tool = canv.toolBox.TryGetToolByName(toolName);

                        return (
                            <div key={toolName} className={styles.toolWrapper}>
                                {toolName === "moreTool" && isShowMoreTool && <MoreWindow />}
                                {toolName === "stickerTool" && isShowStickerToolMenu && (
                                    <StickerMenu />
                                )}
                                {toolName === "arrowTool" && isShowArrowToolMenu && <ArrowMenu />}
                                {toolName === "mindMapTool" && isShowMindMapToolMenu && (
                                    <MindMapMenu />
                                )}
                                {toolName === "penTool" && isShowPenToolMenu && <PenMenu />}
                                {toolName === "templatesTool" && isShowTemplateTool && (
                                    <TemplatesWindow />
                                )}
                                <Tooltip
                                    content={tool.getToolTipName()}
                                    hotkey={tool.getToolHotKey()}
                                    placement="right"
                                >
                                    {/** biome-ignore lint/a11y/noStaticElementInteractions: <explanation> */}
                                    <div
                                        onClick={() => canv.toolBox.switchTo(tool)}
                                        className={cx(
                                            styles.toolBoxWrapperContentItem,
                                            tool.getToolClass(),
                                            {
                                                [styles.toolBoxWrapperContentItemSelected]:
                                                    currentTool.name === toolName,
                                            },
                                        )}
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG from tools
                                        dangerouslySetInnerHTML={{ __html: tool.getToolView() }}
                                    />
                                </Tooltip>
                            </div>
                        );
                    })}
                </VStack>
            </div>
        </div>
    );
};
